<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="800px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="yachtManufacturerDirty.id">
        Edit Yacht Manufacturer
      </span>
      <span v-else>
        Add New Yacht Manufacturer
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-text-field
        v-model="yachtManufacturerDirty.name"
        v-validate="'required'"
        name="name"
        label="Name"
        placeholder="e.g. Example YachtManufacturer d.o.o"
        outlined
        :error-messages="veeErrors.collect('name')"
      />
      <v-autocomplete
        v-model="yachtManufacturerDirty.country_id"
        v-validate="'required'"
        :items="countries.data"
        :loading="countries.loading"
        name="country"
        label="Select Country"
        item-value="id"
        item-text="name"
        autocomplete="disable"
        outlined
        :error-messages="veeErrors.collect('country')"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep'
  import { mapGetters } from 'vuex'
  import ContentDialog from '@/components/helpers/Dialog'
  import YachtManufacturer from '@/models/YachtManufacturer'

  export default {
    name: 'YachtManufacturerEditDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      yachtManufacturer: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        yachtManufacturerDirty: cloneDeep(YachtManufacturer.emptyModel),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      ...mapGetters('settings', ['countries'])
    },
    watch: {
      yachtManufacturer() {
        this.yachtManufacturerDirty = cloneDeep(this.yachtManufacturer)
      }
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validate()

        if (!validation) return

        this.save()
      },
      async save() {
        this.submitting = true

        let data = {
          name: this.yachtManufacturerDirty.name,
          country_id: this.yachtManufacturerDirty.country_id
        }

        try {
          await YachtManufacturer.api.save(data, this.yachtManufacturerDirty.id)

          this.$emit('update:yachtManufacturer')

          this.$store.dispatch('alert', {
            'text': 'Yacht Manufacturer saved',
            'color': 'success'
          })
          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
